const initialState = {
    data : [],
    loading : false
}

export const UserLogin = (state = initialState, action = {}) => {
    switch(action.type){
        case 'USER_LOGIN_REQUEST':
            return{
                ...state,
                loading : true,
                isLogin : false
            }
        case 'USER_LOGIN_SUCCESS':
            return{
                loading : false,
                isLogin : true,
                data : action.payload
            }
        case 'USER_LOGIN_ERROR' :
            return{
                ...state,
                loading : false,
                isLogin : false,
                error : action.payload,
                data : []
            }
        case 'USER_LOGOUT' :
            return{
                data : [],
                loading : false,
                isLogin : false
            }
        default :
            return state
    }
}

export const UserRegister = (state = initialState, action = {}) =>{
    switch(action.type){
        case 'USER_REGISTER_REQUEST':
            return{
                ...state,
                loading : true,
            }
        case 'USER_REGISTER_SUCCESS' :
            return{
                ...state,
                loading : false,
                data : action.payload
            }
        case 'USER_REGISTER_FAILED':
            return{
                ...state,
                loading : false,
                error : action.payload
            }
        default :
            return state
    }
}